import { ChevronRightIcon } from '../../automationStudioIcons';
import { AUTOMATION_STUDIO_EMPTY_FLOW_STEPS } from '../../content';
import styles from '../../../../styles/automationStudio/emptyPanel.module.scss';

export default function EmptyFlowSteps() {
    return (
        <div className={styles.flowRow}>
            {AUTOMATION_STUDIO_EMPTY_FLOW_STEPS.map((step, index) => {
                const Icon = step.icon;
                const isLast = index === AUTOMATION_STUDIO_EMPTY_FLOW_STEPS.length - 1;
                const iconWrapClass = step.id === 'aiGenerates'
                    ? `${styles.flowIconWrap} ${styles.sparkles}`
                    : styles.flowIconWrap;

                return (
                    <span key={step.id} className={styles.flowStepGroup}>
                        <span className={styles.flowStep}>
                            <span className={iconWrapClass}>
                                <Icon className={styles.flowIcon} aria-hidden="true" />
                            </span>
                            <p className={styles.flowStepTitle}>{step.title}</p>
                            <p className={styles.flowStepDescription}>{step.description}</p>
                        </span>
                        {!isLast && (
                            <ChevronRightIcon className={styles.flowArrow} aria-hidden="true" />
                        )}
                    </span>
                );
            })}
        </div>
    );
}
